import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { NewTag } from '../../../components/NewTag';
import { BetaTag } from '../../../components/tag-components';
import { Tooltip } from '../../../components/Tooltip';

export const StyledSectionHeader = styled.header<{ withSectionPadding?: boolean }>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: ${({ withSectionPadding }) => (withSectionPadding ? 0 : '0 16px 8px')};
`;

export const StyledSectionHeaderTitle = styled.h3`
  display: flex;
  align-items: center;
  ${setFontVariant('report', colorsPalettes.carbon[400])};
  font-size: 16px;
  line-height: 18px;
  margin: 0 0 12px;
  width: 100%;
`;

export const StyledSectionHeaderIconTooltip = styled(Tooltip)`
  margin-inline-start: 8px;
`;

export const StyledSectionHeaderIcon = styled(SWReactIcons)`
  svg path {
    fill: ${colorsPalettes.blue[400]};
  }
`;

export const StyledSectionHeaderSubtitle = styled.span`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[250])};
  font-size: 14px;
  margin-inline-end: 8px;
`;

export const StyledSectionHeaderInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const StyledSectionHeaderInfoBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[250])};
  font-size: 12px;
`;

export const StyledNewTag = styled(NewTag)`
  margin: 0 0 0 8px;
`;

export const StyledBetaTag = styled(BetaTag)`
  margin: 0 0 0 8px;
`;

export const StyledHistorycalDataContainer = styled.div`
  margin-left: auto;
`;

export const StyledSectionHeaderInfoIcon = styled(SWReactIcons)`
  svg path:last-child {
    fill: ${colorsPalettes.carbon[200]};
  }
`;
